module.exports = __webpack_public_path__ + "assets/auto_fix_high.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/auto_fix_high.svg
// module id = 219
// module chunks = 0